import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-semibold transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed select-none',
  {
    variants: {
      variant: {
        default:   'bg-primary text-white hover:bg-primary-light shadow-xs',
        secondary: 'bg-bg-light text-text-primary border border-border hover:bg-bg hover:border-border-mid',
        outline:   'border border-border text-text-secondary hover:bg-bg-light',
        ghost:     'text-text-muted hover:bg-bg-light hover:text-text-primary',
        danger:    'bg-error text-white hover:opacity-90',
        success:   'bg-success text-white hover:opacity-90',
      },
      size: {
        sm:   'h-8  px-3 text-xs rounded-[--radius-sm]',
        md:   'h-9  px-4 text-sm rounded-[--radius-md]',
        lg:   'h-11 px-6 text-base rounded-[--radius-md]',
        icon: 'h-9  w-9',
      },
    },
    defaultVariants: { variant: 'default', size: 'md' },
  }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return <Comp ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />;
});
Button.displayName = 'Button';

export { Button, buttonVariants };
